<template lang="pug">
  .buttons(:class="classes")
    button.buttons__button(
      v-if="!currentData.click",
      @click="routerButtonClick",
      :disabled="disabled",
      :class="{ 'buttons__button_with-margin' : currentData.link }") {{ currentData.text }}
    button.buttons__button(
      v-else,
      :disabled="disabled",
      :class="{ 'buttons__button_with-margin' : currentData.link }"
      @click="$emit(currentData.click)") {{ currentData.text }}
    .buttons__link(
      v-if="currentData.link",
      @click="linkClick") {{ currentData.link.text }}
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Buttons',
  props: ['type', 'position', 'disabled'],
  computed: {
    currentData() {
      return this.items.find(item => item.id === this.type);
    },
    classes() {
      const classes = [];

      if (this.position) {
        classes.push(`buttons_${this.position}`);
      }
      if (this.currentData.link) {
        classes.push('buttons_with-link');
      }

      return classes;
    },
  },
  methods: {
    ...mapMutations(['set_isLicense']),
    routerButtonClick() {
      if (this.type === 'trial') {
        this.set_isLicense(true);
      }
      this.$router.push({ name: this.currentData.to });
    },
    linkClick() {
      if (['enter', 'trial'].includes(this.type)) {
        this.set_isLicense(false);
        this.$emit('reset');
      }
      this.$router.push({ name: this.currentData.link.href });
    },
  },
  data() {
    return {
      items: [
        {
          id: 'enter',
          text: 'Попробовать снова',
          click: 'reset',
        },
        {
          id: 'play',
          mod: 'no-margin',
          text: 'Play more',
          click: 'reset',
        },
        {
          id: 'trial',
          text: 'Узнать правила',
          to: 'Rules',
        },
        {
          id: 'rules',
          text: 'Далее',
          click: 'next',
          link: {
            text: 'Пропустить',
            href: 'GoodLuck',
          },
        },
        {
          id: 'next',
          text: 'Далее',
          to: 'Game',
        },
        {
          id: 'go',
          text: "Let's go",
          click: 'reset',
        },
        {
          id: 'auth',
          text: 'Send',
          click: 'checkIn',
          link: {
            text: 'Back',
            href: 'Hello',
          },
        },
        {
          id: 'license',
          text: 'Send',
          click: 'debouncedCheck',
          link: {
            text: 'Back',
            href: 'Hello',
          },
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
  .buttons {
    position: absolute;
    @include vertical-align;
    flex-direction: column;
    top: $frame-top;
    left: $gutter-width;
    right: $gutter-width;
    @media (max-width: $max-width-xs) {
      top: auto;
      bottom: 90px;
    }
    &_relative {
      position: relative;
      top: auto;
      left: auto;
      right: auto;
      bottom: auto;
      @media (max-width: $max-width-xs) {
        width: 100%;
      }
    }
    &_with-link {
      @media (max-width: $max-width-xs) {
        bottom: $frame-bottom-xs;
      }
    }
    &__button {
      @include main-button;
      &_with-margin {
        margin: 0 0 $button-margin-bottom;
        @media (max-width: $max-width-xs) {
          margin: 0 0 $button-margin-bottom-xs;
        }
      }
    }
    &__link {
      @include main-link;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UI/Buttons.vue